import { render, staticRenderFns } from "./basic-chart.vue?vue&type=template&id=7cc67a55&scoped=true"
import script from "./basic-chart.vue?vue&type=script&lang=js"
export * from "./basic-chart.vue?vue&type=script&lang=js"
import style0 from "./basic-chart.vue?vue&type=style&index=0&id=7cc67a55&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc67a55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cc67a55')) {
      api.createRecord('7cc67a55', component.options)
    } else {
      api.reload('7cc67a55', component.options)
    }
    module.hot.accept("./basic-chart.vue?vue&type=template&id=7cc67a55&scoped=true", function () {
      api.rerender('7cc67a55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/basic-chart.vue"
export default component.exports